import { apiRequest } from "../../index";
import config from "../../../../config";

// End-of-session chatbot reports (bots-api). Kept local until these move into
// @nualang/nualang-api-and-queries alongside the other Bots API calls.
const api = `${config.API}/bots`;

export async function createBotSessionReport(botId, body) {
  const response = await apiRequest(
    `${api}/${encodeURIComponent(botId)}/reports`,
    "POST",
    body,
  );
  return response;
}

// Always bypasses the cache: the report is polled until it is ready.
export async function getBotSessionReport({ botId, memberId, createdAt }) {
  const response = await apiRequest(
    `${api}/${encodeURIComponent(botId)}/reports/${encodeURIComponent(memberId)}/${createdAt}`,
    "GET",
    undefined,
    false,
    true,
  );
  return response;
}
